import { API_ENDPOINTS } from '@/utils/endpoints';
import { BaseService } from '../baseService';
import { LoginResponse } from '../models/User';

export class AuthService {
  /**
   * @function login
   * @param email user login email
   * @param password user login password
   * @returns LoginResponse
   */
  // static login = async (email: string, password: string): Promise<LoginResponse> => {
  //   // Implementation
  //   const response = await BaseService.post<LoginResponse>(API_ENDPOINTS.GET_USER_DETAIL, {
  //     email,
  //     password,
  //   });
  static fetchUserDetail = async (userId: string): Promise<LoginResponse> => {
    const response = await BaseService.post<LoginResponse>(API_ENDPOINTS.GET_USER_DETAIL, {
      userId,
    });
    return response;
  };
}
